export const DEATH_VISIT_LABELS = {
  id: "Id",
  uuid: "UUID",
  tenantId: "Tenant Id",
  createdBy: "Created By",
  createdDte: "Created Date",
  updatedBy: "Updated By",
  updatedDte: "Updated Date",
  version: "Version",
  activeFlg: "Active Flag",
  datetimeOfDeath: "Date / Time of Death",
  datetimeNotified: "Date / Time Notified",
  patChartId: "Patient Chart Id",
  locationOfDeath: "Location of Death",
  locationOfDeathOther: "Location of Death (Other)",
  hospicePhysicianNotified: "Hospice Physician Notified",
  hospicePhysicianNotifiedComment: "Hospice Physician Notified (Comment)",
  coronerMedicalExaminerRequiresNotification:
    "Coroner / Medical Examiner Requires Notification",
  coronerMedicalExaminerRequiresNotificationComment:
    "Coroner / Medical Examiner Requires Notification (Comment)",
  notificationAttendingPhysician: "Notification Attending Physician",
  attendingPhysicianComment: "Attending Physician (Comment)",
  notifiedByOther: "Notified By (Other)",
  pharmacyNotified: "Pharmacy Notified",
  pharmacyNotifiedComment: "Pharmacy Notified (Comment)",
  dmeSupplierNotified: "DME Supplier Notified",
  dmeSupplierNotifiedComment: "DME Supplier Notified (Comment)",
  funeralHomeNotified: "Funeral Home Notified",
  funeralHomeNotifiedComment: "Funeral Home Notified (Comment)",
  bodyReceivedBy: "Body Received By",
  personalItems: "Personal Items",
  personalItemsComment: "Personal Items (Comment)",
  wasDeathAttendedByHospiceStaff: "Was Death Attended By Hospice Staff",
  emotionalResponseFromCaregivers: "Emotional Response From Caregivers",
  emotionalResponseFromCaregiversOther:
    "Emotional Response From Caregivers (Other)",
  supportOffered: "Support Offered",
  supportOfferedComment: "Support Offered (Comment)",
  planForBereavementFollowUp: "Plan For Bereavement Follow Up",
  planForBereavementFollowUpComment: "Plan For Bereavement Follow Up (Comment)",
  familyProvidedTimeAndSpaceToGrieve:
    "Family Provided Time And Space To Grieve",
  familyProvidedTimeAndSpaceToGrieveComment:
    "Family Provided Time And Space To Grieve (Comment)",
  wasDeathAttendedByHospiceStaffComment:
    "Was Death Attended By Hospice Staff (Comment)",
  notifiedBy: "Notified By",
  history: "History",
} as const;

// Type for the keys of DEATH_VISIT_LABELS
export type DeathVisitLabelKey = keyof typeof DEATH_VISIT_LABELS;

/**
 * Type guard to check if a string is a valid DeathVisitLabelKey
 * @param key - The string to check
 * @returns True if the key exists in DEATH_VISIT_LABELS
 */
export function isDeathVisitLabelKey(key: string): key is DeathVisitLabelKey {
  return key in DEATH_VISIT_LABELS;
}

/**
 * Runtime-safe getter function to retrieve death visit labels by key.
 * Accepts dynamic string values (e.g., from API responses) and performs
 * runtime validation to safely retrieve labels.
 *
 * @param key - The label key as a string (can be dynamic/unknown at compile time)
 * @param fallback - Optional fallback string if label is not found
 * @returns The label string, fallback value, or the key itself
 *
 * @example
 * // With known key
 * const label = getDeathVisitLabel('datetimeOfDeath'); // "Date / Time of Death"
 *
 * // With dynamic API value
 * const apiKey = record.changesMadeTo; // string from API
 * const label = getDeathVisitLabel(apiKey); // Safe lookup
 *
 * // With fallback
 * const label = getDeathVisitLabel(unknownKey, 'Unknown Field');
 */
export function getDeathVisitLabel(key: string, fallback?: string): string {
  if (isDeathVisitLabelKey(key)) {
    return DEATH_VISIT_LABELS[key];
  }
  return fallback ?? key;
}



// WEBPACK FOOTER //
// ./src/providers/death-visit-history/death-visit-labels.ts